// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__197bd","field":"styles_field__Qvn8f","fieldCol":"styles_fieldCol__9yqCv","diffCol":"styles_diffCol__1j8ej","diff":"styles_diff__1dJZE"};